export enum ButtonVariant {
    Link = 'link',
    PrimaryOutline = 'outline-primary',
    SecondaryOutline = 'outline-secondary',
    SuccessOutline = 'outline-success',
    DangerOutline = 'outline-danger',
    WarningOutline = 'outline-warning',
    InfoOutline = 'outline-info',
    DarkOutline = 'outline-dark',
    LightOutline = 'outline-light',
    Primary = 'primary',
    Secondary = 'secondary',
    Success = 'success',
    Danger = 'danger',
    Warning = 'warning',
    Info = 'info',
    Dark = 'dark',
    Light = 'light'
}; 

export enum BGVariant {
    Primary = 'bg-primary',
    Secondary = 'bg-secondary',
    Success = 'bg-success',
    Danger = 'bg-danger',
    Warning = 'bg-warning',
    Info = 'bg-info',
    Dark = 'bg-dark',
    Light = 'bg-light'
};

export enum ButtonStyle {
    RoundedLeft = 'rounded-start-5',
    RoundedRight = 'rounded-end-5',
};